<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入分类名称" :maxLength="50" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" placeholder="请输入排序值" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="4" :maxLength="200" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addArticleType, editArticleType, getArticleType } from '@/api/tutorial/articleType'

export default {
  name: 'CreateForm',
  data() {
    return {
      open: false,
      submitLoading: false,
      showLoading: false,
      formTitle: '新增分类',
      form: {
        id: undefined,
        name: '',
        remark: '',
        sort: 0,
      },
      rules: {
        name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formTitle = '新增分类'
      this.open = true
    },
    /** 表单重置 */
    reset() {
      this.form = {
        id: undefined,
        name: '',
        remark: '',
        sort: 0,
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      if (!id) {
        this.$message.error('缺少必要参数')
        return
      }
      this.formTitle = '编辑分类'
      getArticleType(id)
        .then((response) => {
          if (response.code === '20001' || response.success) {
            const data = response.data || {}
            this.form = {
              id: data.id,
              name: data.name || '',
              remark: data.remark || '',
              sort: data.sort || 0,
            }
            this.open = true
          } else {
            this.$message.error(response.message || '获取分类详情失败')
          }
        })
        .catch(() => {
          this.$message.error('获取分类详情失败')
        })
    },
    /** 关闭确认 */
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },
    /** 取消按钮 */
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    /** 提交表单 */
    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          const submitData = {
            name: this.form.name,
            pid: '',
            remark: this.form.remark || '',
            sort: this.form.sort || 0,
          }
          // 如果有id则是编辑，否则是新增
          const isEdit = this.form.id !== undefined
          if (isEdit) {
            submitData.id = this.form.id
          }
          const apiCall = isEdit ? editArticleType(submitData) : addArticleType(submitData)
          apiCall
            .then((response) => {
              if (response.code === '20001' || response.success) {
                this.$message.success(isEdit ? '编辑成功' : '新增成功', 3)
                this.open = false
                this.reset()
                this.$emit('ok')
              } else {
                const messages = Object.values(object || {}).flatMap((errorArray) =>
                  errorArray.map((item) => item.message)
                )
                this.showLoading = true
                this.$nextTick(() => {
                  this.$refs.LoadingPop &&
                    this.$refs.LoadingPop.init(2, messages || [response.message || (isEdit ? '编辑失败' : '新增失败')])
                })
              }
            })
            .catch(() => {
              this.$message.error(isEdit ? '编辑失败' : '新增失败')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
